module.exports = __webpack_public_path__ + "static/media/fuelopslogo.3c5d44b4.png";